/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const updateClient = /* GraphQL */ `mutation UpdateClient($input: ClientInput!) {
  updateClient(input: $input) {
    id
    firstName
    lastName
    phone
    email
    image
    referralSource
    hasShopper
    signupTimestamp
    attnPassword
    deactivated
    hasStreamUser
    preferences {
      id
      surveys {
        id
        completedTimestamp
        name
        responses {
          id
          question
          response
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClientMutationVariables,
  APITypes.UpdateClientMutation
>;
export const updateLinkedClient = /* GraphQL */ `mutation UpdateLinkedClient(
  $clientId: ID!
  $clientEmail: String
  $orderShopperId: String
  $orderId: String
  $deliveryTimestamp: String
  $input: LinkedClientInput!
) {
  updateLinkedClient(
    clientId: $clientId
    clientEmail: $clientEmail
    orderShopperId: $orderShopperId
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
    input: $input
  ) {
    id
    client {
      id
      firstName
      lastName
      phone
      email
      image
      referralSource
      hasShopper
      signupTimestamp
      attnPassword
      deactivated
      hasStreamUser
      preferences {
        id
        surveys {
          id
          completedTimestamp
          name
          responses {
            id
            question
            response
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    note
    orderCount
    lastOrderTimestamp
    firstConnectTimestamp
    referralSourceMessage
    clientAnnotation {
      id
      note
      image
      noteLastUpdatedTimestamp
      preferencesLastUpdatedTimestamp
      preferencesLastSeenTimestamp
      needsToSeePreferences
      __typename
    }
    lastInviteTimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLinkedClientMutationVariables,
  APITypes.UpdateLinkedClientMutation
>;
export const resendWixOrderConfirmation = /* GraphQL */ `mutation ResendWixOrderConfirmation(
  $clientId: ID!
  $clientEmail: String
  $input: LinkedOrderIdentifiersInput!
) {
  resendWixOrderConfirmation(
    clientId: $clientId
    clientEmail: $clientEmail
    input: $input
  )
}
` as GeneratedMutation<
  APITypes.ResendWixOrderConfirmationMutationVariables,
  APITypes.ResendWixOrderConfirmationMutation
>;
export const createAddress = /* GraphQL */ `mutation CreateAddress($input: AddressInput!) {
  createAddress(input: $input) {
    id
    addressName
    addressLine1
    addressLine2
    city
    state
    zipcode
    country
    isDefault
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAddressMutationVariables,
  APITypes.CreateAddressMutation
>;
export const updateAddress = /* GraphQL */ `mutation UpdateAddress($id: ID!, $input: AddressInput!) {
  updateAddress(id: $id, input: $input) {
    id
    addressName
    addressLine1
    addressLine2
    city
    state
    zipcode
    country
    isDefault
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAddressMutationVariables,
  APITypes.UpdateAddressMutation
>;
export const deleteAddress = /* GraphQL */ `mutation DeleteAddress($id: ID!) {
  deleteAddress(id: $id) {
    id
    addressName
    addressLine1
    addressLine2
    city
    state
    zipcode
    country
    isDefault
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAddressMutationVariables,
  APITypes.DeleteAddressMutation
>;
export const createPaymentMethod = /* GraphQL */ `mutation CreatePaymentMethod($input: PaymentMethodInput!) {
  createPaymentMethod(input: $input) {
    id
    brand
    expirationMonth
    expirationYear
    last4
    isDefault
    address {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePaymentMethodMutationVariables,
  APITypes.CreatePaymentMethodMutation
>;
export const updatePaymentMethod = /* GraphQL */ `mutation UpdatePaymentMethod($id: ID!, $input: PaymentMethodInput!) {
  updatePaymentMethod(id: $id, input: $input) {
    id
    brand
    expirationMonth
    expirationYear
    last4
    isDefault
    address {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePaymentMethodMutationVariables,
  APITypes.UpdatePaymentMethodMutation
>;
export const deletePaymentMethod = /* GraphQL */ `mutation DeletePaymentMethod($id: ID!) {
  deletePaymentMethod(id: $id) {
    id
    brand
    expirationMonth
    expirationYear
    last4
    isDefault
    address {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePaymentMethodMutationVariables,
  APITypes.DeletePaymentMethodMutation
>;
export const createClientOrder = /* GraphQL */ `mutation CreateClientOrder($input: OrderInput) {
  createClientOrder(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClientOrderMutationVariables,
  APITypes.CreateClientOrderMutation
>;
export const createClientOrderV2 = /* GraphQL */ `mutation CreateClientOrderV2($input: OrderInputV2) {
  createClientOrderV2(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClientOrderV2MutationVariables,
  APITypes.CreateClientOrderV2Mutation
>;
export const clientCancelOrder = /* GraphQL */ `mutation ClientCancelOrder($id: ID!, $orderTimestamp: String!) {
  clientCancelOrder(id: $id, orderTimestamp: $orderTimestamp) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ClientCancelOrderMutationVariables,
  APITypes.ClientCancelOrderMutation
>;
export const deleteLinkedClient = /* GraphQL */ `mutation DeleteLinkedClient($id: ID!) {
  deleteLinkedClient(id: $id) {
    id
    client {
      id
      firstName
      lastName
      phone
      email
      image
      referralSource
      hasShopper
      signupTimestamp
      attnPassword
      deactivated
      hasStreamUser
      preferences {
        id
        surveys {
          id
          completedTimestamp
          name
          responses {
            id
            question
            response
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    note
    orderCount
    lastOrderTimestamp
    firstConnectTimestamp
    referralSourceMessage
    clientAnnotation {
      id
      note
      image
      noteLastUpdatedTimestamp
      preferencesLastUpdatedTimestamp
      preferencesLastSeenTimestamp
      needsToSeePreferences
      __typename
    }
    lastInviteTimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLinkedClientMutationVariables,
  APITypes.DeleteLinkedClientMutation
>;
export const inviteClient = /* GraphQL */ `mutation InviteClient($input: ClientInput) {
  inviteClient(input: $input) {
    id
    firstName
    lastName
    phone
    email
    image
    referralSource
    hasShopper
    signupTimestamp
    attnPassword
    deactivated
    hasStreamUser
    preferences {
      id
      surveys {
        id
        completedTimestamp
        name
        responses {
          id
          question
          response
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.InviteClientMutationVariables,
  APITypes.InviteClientMutation
>;
export const inviteClientV2 = /* GraphQL */ `mutation InviteClientV2($input: ClientInput) {
  inviteClientV2(input: $input) {
    id
    client {
      id
      firstName
      lastName
      phone
      email
      image
      referralSource
      hasShopper
      signupTimestamp
      attnPassword
      deactivated
      hasStreamUser
      preferences {
        id
        surveys {
          id
          completedTimestamp
          name
          responses {
            id
            question
            response
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    note
    orderCount
    lastOrderTimestamp
    firstConnectTimestamp
    referralSourceMessage
    clientAnnotation {
      id
      note
      image
      noteLastUpdatedTimestamp
      preferencesLastUpdatedTimestamp
      preferencesLastSeenTimestamp
      needsToSeePreferences
      __typename
    }
    lastInviteTimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.InviteClientV2MutationVariables,
  APITypes.InviteClientV2Mutation
>;
export const deleteInviteClientV2 = /* GraphQL */ `mutation DeleteInviteClientV2($id: ID!) {
  deleteInviteClientV2(id: $id) {
    id
    client {
      id
      firstName
      lastName
      phone
      email
      image
      referralSource
      hasShopper
      signupTimestamp
      attnPassword
      deactivated
      hasStreamUser
      preferences {
        id
        surveys {
          id
          completedTimestamp
          name
          responses {
            id
            question
            response
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    note
    orderCount
    lastOrderTimestamp
    firstConnectTimestamp
    referralSourceMessage
    clientAnnotation {
      id
      note
      image
      noteLastUpdatedTimestamp
      preferencesLastUpdatedTimestamp
      preferencesLastSeenTimestamp
      needsToSeePreferences
      __typename
    }
    lastInviteTimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInviteClientV2MutationVariables,
  APITypes.DeleteInviteClientV2Mutation
>;
export const updateShopper = /* GraphQL */ `mutation UpdateShopper($input: ShopperInput!) {
  updateShopper(input: $input) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShopperMutationVariables,
  APITypes.UpdateShopperMutation
>;
export const createShopperIdentity = /* GraphQL */ `mutation CreateShopperIdentity($input: IdentityCreateInput!) {
  createShopperIdentity(input: $input) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateShopperIdentityMutationVariables,
  APITypes.CreateShopperIdentityMutation
>;
export const updateShopperIdentity = /* GraphQL */ `mutation UpdateShopperIdentity($input: IdentityUpdateInput!) {
  updateShopperIdentity(input: $input) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShopperIdentityMutationVariables,
  APITypes.UpdateShopperIdentityMutation
>;
export const requestChargeCard = /* GraphQL */ `mutation RequestChargeCard(
  $name: String
  $addressLine1: String
  $addressLine2: String
  $city: String
  $state: String
  $zipcode: String
  $ipAddr: String
) {
  requestChargeCard(
    name: $name
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    city: $city
    state: $state
    zipcode: $zipcode
    ipAddr: $ipAddr
  ) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RequestChargeCardMutationVariables,
  APITypes.RequestChargeCardMutation
>;
export const updateServicesOrdering = /* GraphQL */ `mutation UpdateServicesOrdering($input: ServiceOfferingIdsInput) {
  updateServicesOrdering(input: $input) {
    serviceOfferingIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateServicesOrderingMutationVariables,
  APITypes.UpdateServicesOrderingMutation
>;
export const createServiceOffering = /* GraphQL */ `mutation CreateServiceOffering($input: ServiceOfferingInput) {
  createServiceOffering(input: $input) {
    id
    serviceName
    serviceImage
    serviceDescription
    defaultErrandBusinessNames
    baseFee
    maxErrands
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    disclaimerText
    useSuggestedPricing
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateServiceOfferingMutationVariables,
  APITypes.CreateServiceOfferingMutation
>;
export const updateServiceOffering = /* GraphQL */ `mutation UpdateServiceOffering($id: ID, $input: ServiceOfferingInput) {
  updateServiceOffering(id: $id, input: $input) {
    id
    serviceName
    serviceImage
    serviceDescription
    defaultErrandBusinessNames
    baseFee
    maxErrands
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    disclaimerText
    useSuggestedPricing
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateServiceOfferingMutationVariables,
  APITypes.UpdateServiceOfferingMutation
>;
export const deleteServiceOffering = /* GraphQL */ `mutation DeleteServiceOffering($id: ID) {
  deleteServiceOffering(id: $id) {
    id
    serviceName
    serviceImage
    serviceDescription
    defaultErrandBusinessNames
    baseFee
    maxErrands
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    disclaimerText
    useSuggestedPricing
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteServiceOfferingMutationVariables,
  APITypes.DeleteServiceOfferingMutation
>;
export const createServiceOfferingV2 = /* GraphQL */ `mutation CreateServiceOfferingV2(
  $id: ID
  $serviceName: String
  $serviceImage: String
  $flatFee: String
  $percent: String
  $minFee: String
  $clientPaysPlatform: Boolean
  $preTipPercentages: [String]
  $defaultPercentagesIndex: Int
  $fixedGratuityOptions: [Int]
  $defaultFixedGratuityOptionsIndex: Int
  $useSuggestedPricing: Boolean
) {
  createServiceOfferingV2(
    id: $id
    serviceName: $serviceName
    serviceImage: $serviceImage
    flatFee: $flatFee
    percent: $percent
    minFee: $minFee
    clientPaysPlatform: $clientPaysPlatform
    preTipPercentages: $preTipPercentages
    defaultPercentagesIndex: $defaultPercentagesIndex
    fixedGratuityOptions: $fixedGratuityOptions
    defaultFixedGratuityOptionsIndex: $defaultFixedGratuityOptionsIndex
    useSuggestedPricing: $useSuggestedPricing
  ) {
    id
    serviceName
    serviceImage
    serviceDescription
    defaultErrandBusinessNames
    baseFee
    maxErrands
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    disclaimerText
    useSuggestedPricing
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateServiceOfferingV2MutationVariables,
  APITypes.CreateServiceOfferingV2Mutation
>;
export const updateServiceOfferingV2 = /* GraphQL */ `mutation UpdateServiceOfferingV2(
  $id: ID
  $serviceName: String
  $serviceImage: String
  $flatFee: String
  $percent: String
  $minFee: String
  $clientPaysPlatform: Boolean
  $preTipPercentages: [String]
  $defaultPercentagesIndex: Int
  $fixedGratuityOptions: [Int]
  $defaultFixedGratuityOptionsIndex: Int
  $useSuggestedPricing: Boolean
) {
  updateServiceOfferingV2(
    id: $id
    serviceName: $serviceName
    serviceImage: $serviceImage
    flatFee: $flatFee
    percent: $percent
    minFee: $minFee
    clientPaysPlatform: $clientPaysPlatform
    preTipPercentages: $preTipPercentages
    defaultPercentagesIndex: $defaultPercentagesIndex
    fixedGratuityOptions: $fixedGratuityOptions
    defaultFixedGratuityOptionsIndex: $defaultFixedGratuityOptionsIndex
    useSuggestedPricing: $useSuggestedPricing
  ) {
    id
    serviceName
    serviceImage
    serviceDescription
    defaultErrandBusinessNames
    baseFee
    maxErrands
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    disclaimerText
    useSuggestedPricing
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateServiceOfferingV2MutationVariables,
  APITypes.UpdateServiceOfferingV2Mutation
>;
export const updateDailySchedules = /* GraphQL */ `mutation UpdateDailySchedules($input: DailySchedulesInput) {
  updateDailySchedules(input: $input) {
    id
    dailySchedules {
      id
      day
      timeSlots {
        id
        slotStart
        slotEnd
        isActive
        bufferDuration
        bufferMode
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDailySchedulesMutationVariables,
  APITypes.UpdateDailySchedulesMutation
>;
export const updateDailySchedulesV2 = /* GraphQL */ `mutation UpdateDailySchedulesV2($input: [DailySchedulesInputV2]) {
  updateDailySchedulesV2(input: $input) {
    dailySchedules {
      id
      day
      timeSlots {
        id
        slotStart
        slotEnd
        maxOrders
        bufferDuration
        bufferMode
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDailySchedulesV2MutationVariables,
  APITypes.UpdateDailySchedulesV2Mutation
>;
export const updateScheduleOptions = /* GraphQL */ `mutation UpdateScheduleOptions($input: ShopperScheduleOptionsInput) {
  updateScheduleOptions(input: $input) {
    defaultMaxOrders
    defaultTimeSlotDuration
    isScheduleAvailable
    defaultBufferDuration
    defaultBufferMode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScheduleOptionsMutationVariables,
  APITypes.UpdateScheduleOptionsMutation
>;
export const updateClosedDateRanges = /* GraphQL */ `mutation UpdateClosedDateRanges($input: ClosedDateRangesInput) {
  updateClosedDateRanges(input: $input) {
    closedDateRanges {
      id
      startDate
      endDate
      description
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClosedDateRangesMutationVariables,
  APITypes.UpdateClosedDateRangesMutation
>;
export const activateChargeCard = /* GraphQL */ `mutation ActivateChargeCard($input: ChargeCardInput!) {
  activateChargeCard(input: $input) {
    id
    brand
    expirationMonth
    expirationYear
    last4
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ActivateChargeCardMutationVariables,
  APITypes.ActivateChargeCardMutation
>;
export const createStripeConnectAccount = /* GraphQL */ `mutation CreateStripeConnectAccount($input: StripeConnectAccountInput) {
  createStripeConnectAccount(input: $input) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStripeConnectAccountMutationVariables,
  APITypes.CreateStripeConnectAccountMutation
>;
export const createStripeConnectAccountV2 = /* GraphQL */ `mutation CreateStripeConnectAccountV2($input: StripeConnectAccountInput) {
  createStripeConnectAccountV2(input: $input) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStripeConnectAccountV2MutationVariables,
  APITypes.CreateStripeConnectAccountV2Mutation
>;
export const upgradeStripeConnectAccountFromV1ToV2 = /* GraphQL */ `mutation UpgradeStripeConnectAccountFromV1ToV2(
  $input: StripeConnectAccountInput
) {
  upgradeStripeConnectAccountFromV1ToV2(input: $input) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpgradeStripeConnectAccountFromV1ToV2MutationVariables,
  APITypes.UpgradeStripeConnectAccountFromV1ToV2Mutation
>;
export const createDirectDepositAccount = /* GraphQL */ `mutation CreateDirectDepositAccount($input: DirectDepositAccountInput) {
  createDirectDepositAccount(input: $input) {
    id
    bankName
    accountHolderName
    routingNumber
    last4
    error
    isDefault
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDirectDepositAccountMutationVariables,
  APITypes.CreateDirectDepositAccountMutation
>;
export const updateDirectDepositAccount = /* GraphQL */ `mutation UpdateDirectDepositAccount(
  $id: ID
  $input: DirectDepositAccountInput
) {
  updateDirectDepositAccount(id: $id, input: $input) {
    id
    bankName
    accountHolderName
    routingNumber
    last4
    error
    isDefault
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDirectDepositAccountMutationVariables,
  APITypes.UpdateDirectDepositAccountMutation
>;
export const deleteDirectDepositAccount = /* GraphQL */ `mutation DeleteDirectDepositAccount($id: ID) {
  deleteDirectDepositAccount(id: $id) {
    id
    bankName
    accountHolderName
    routingNumber
    last4
    error
    isDefault
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDirectDepositAccountMutationVariables,
  APITypes.DeleteDirectDepositAccountMutation
>;
export const updateServiceArea = /* GraphQL */ `mutation UpdateServiceArea($input: ServiceAreaInput) {
  updateServiceArea(input: $input) {
    id
    city
    state
    zipcode
    description
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateServiceAreaMutationVariables,
  APITypes.UpdateServiceAreaMutation
>;
export const createServiceTime = /* GraphQL */ `mutation CreateServiceTime($input: ServiceTimeInput) {
  createServiceTime(input: $input) {
    dayOfWeek
    startTime
    endTime
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateServiceTimeMutationVariables,
  APITypes.CreateServiceTimeMutation
>;
export const updateServiceTime = /* GraphQL */ `mutation UpdateServiceTime($id: ID, $input: ServiceTimeInput) {
  updateServiceTime(id: $id, input: $input) {
    dayOfWeek
    startTime
    endTime
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateServiceTimeMutationVariables,
  APITypes.UpdateServiceTimeMutation
>;
export const deleteServiceTime = /* GraphQL */ `mutation DeleteServiceTime($id: ID) {
  deleteServiceTime(id: $id) {
    dayOfWeek
    startTime
    endTime
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteServiceTimeMutationVariables,
  APITypes.DeleteServiceTimeMutation
>;
export const createCoupon = /* GraphQL */ `mutation CreateCoupon($input: CouponInput) {
  createCoupon(input: $input) {
    id
    couponCode
    couponValue
    paidByShopper
    validClientIds
    usesPerClient
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCouponMutationVariables,
  APITypes.CreateCouponMutation
>;
export const updateCoupon = /* GraphQL */ `mutation UpdateCoupon($id: ID, $input: CouponInput) {
  updateCoupon(id: $id, input: $input) {
    id
    couponCode
    couponValue
    paidByShopper
    validClientIds
    usesPerClient
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCouponMutationVariables,
  APITypes.UpdateCouponMutation
>;
export const deleteCoupon = /* GraphQL */ `mutation DeleteCoupon($id: ID) {
  deleteCoupon(id: $id) {
    id
    couponCode
    couponValue
    paidByShopper
    validClientIds
    usesPerClient
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCouponMutationVariables,
  APITypes.DeleteCouponMutation
>;
export const updateShoppingList = /* GraphQL */ `mutation UpdateShoppingList($input: ItemsStateInput) {
  updateShoppingList(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShoppingListMutationVariables,
  APITypes.UpdateShoppingListMutation
>;
export const useTransactions = /* GraphQL */ `mutation UseTransactions($input: UseTransactionsInput) {
  useTransactions(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UseTransactionsMutationVariables,
  APITypes.UseTransactionsMutation
>;
export const dissociateTransaction = /* GraphQL */ `mutation DissociateTransaction($input: UseTransactionsInput) {
  dissociateTransaction(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DissociateTransactionMutationVariables,
  APITypes.DissociateTransactionMutation
>;
export const addOrderAdjustment = /* GraphQL */ `mutation AddOrderAdjustment($input: OrderAdjustmentInput) {
  addOrderAdjustment(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddOrderAdjustmentMutationVariables,
  APITypes.AddOrderAdjustmentMutation
>;
export const updateOrderAdjustment = /* GraphQL */ `mutation UpdateOrderAdjustment($input: OrderAdjustmentInput) {
  updateOrderAdjustment(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderAdjustmentMutationVariables,
  APITypes.UpdateOrderAdjustmentMutation
>;
export const removeOrderAdjustment = /* GraphQL */ `mutation RemoveOrderAdjustment($input: OrderAdjustmentInput) {
  removeOrderAdjustment(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveOrderAdjustmentMutationVariables,
  APITypes.RemoveOrderAdjustmentMutation
>;
export const addOrderAdjustment2 = /* GraphQL */ `mutation AddOrderAdjustment2($input: OrderAdjustmentInput) {
  addOrderAdjustment2(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddOrderAdjustment2MutationVariables,
  APITypes.AddOrderAdjustment2Mutation
>;
export const removeOrderAdjustment2 = /* GraphQL */ `mutation RemoveOrderAdjustment2(
  $id: ID!
  $orderId: ID!
  $deliveryTimestamp: String!
) {
  removeOrderAdjustment2(
    id: $id
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveOrderAdjustment2MutationVariables,
  APITypes.RemoveOrderAdjustment2Mutation
>;
export const addOrderCredit = /* GraphQL */ `mutation AddOrderCredit(
  $orderId: ID!
  $deliveryTimestamp: String!
  $description: String!
  $amount: Int!
) {
  addOrderCredit(
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
    description: $description
    amount: $amount
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddOrderCreditMutationVariables,
  APITypes.AddOrderCreditMutation
>;
export const removeOrderCredit = /* GraphQL */ `mutation RemoveOrderCredit(
  $id: ID!
  $orderId: ID!
  $deliveryTimestamp: String!
) {
  removeOrderCredit(
    id: $id
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveOrderCreditMutationVariables,
  APITypes.RemoveOrderCreditMutation
>;
export const updateOrderNotes = /* GraphQL */ `mutation UpdateOrderNotes($input: OrderNotesInput!) {
  updateOrderNotes(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderNotesMutationVariables,
  APITypes.UpdateOrderNotesMutation
>;
export const addOrderExternalTransaction = /* GraphQL */ `mutation AddOrderExternalTransaction($input: OrderExternalTransactionInput!) {
  addOrderExternalTransaction(input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      moreAttachments
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddOrderExternalTransactionMutationVariables,
  APITypes.AddOrderExternalTransactionMutation
>;
export const removeOrderExternalTransaction = /* GraphQL */ `mutation RemoveOrderExternalTransaction(
  $id: ID!
  $input: OrderExternalTransactionRemovalInput!
) {
  removeOrderExternalTransaction(id: $id, input: $input) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveOrderExternalTransactionMutationVariables,
  APITypes.RemoveOrderExternalTransactionMutation
>;
export const completeOrder = /* GraphQL */ `mutation CompleteOrder($id: ID!, $deliveryTimestamp: String!) {
  completeOrder(id: $id, deliveryTimestamp: $deliveryTimestamp) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CompleteOrderMutationVariables,
  APITypes.CompleteOrderMutation
>;
export const cancelOrder = /* GraphQL */ `mutation CancelOrder($id: ID!, $deliveryTimestamp: String!) {
  cancelOrder(id: $id, deliveryTimestamp: $deliveryTimestamp) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CancelOrderMutationVariables,
  APITypes.CancelOrderMutation
>;
export const associateClientWithShopper = /* GraphQL */ `mutation AssociateClientWithShopper($input: ReferralLinkInput) {
  associateClientWithShopper(input: $input) {
    linkType
    shopperId
    webPath
    meta
    linkedShopper {
      id
      shopper {
        id
        firstName
        lastName
        displayName
        deliveryArea
        websiteUrl
        phone
        businessPhone
        email
        bio
        image
        businessName
        availabilityDescription
        announcement
        rating
        repeatClientCount
        orderCount
        reviewCount
        specialtyTags
        tagline
        metaTitle
        metaImage
        metaDescription
        deliveryAreaZipcode
        deliveryAreaZipcodes
        deliveryRadius
        lowestPrice
        subscriptionPlan
        subscriptionPlanDetails {
          id
          textComponents {
            text
            bold
            __typename
          }
          phases {
            id
            status
            __typename
          }
          __typename
        }
        branding {
          coverColor
          __typename
        }
        typicalPricing {
          summary {
            title
            description
            __typename
          }
          groceries
          shoppingAndDelivery
          minGratuity
          platform
          __typename
        }
        allowClientConnection
        stripeConnectAcctExists
        fullSSNRequired
        attnBizProfile
        attnDirectDeposit
        attnCreditCard
        attnServices
        attnPassword
        statusIdentityVerification {
          state
          message
          externalLink
          __typename
        }
        statusChargeCard {
          state
          message
          externalLink
          __typename
        }
        optInEngage
        optInZipcode
        deactivated
        acceptsReferralNetwork
        __typename
      }
      serviceOfferings {
        id
        serviceName
        serviceImage
        serviceDescription
        defaultErrandBusinessNames
        baseFee
        maxErrands
        pricingModel {
          version
          description
          flatPm {
            fee
            feeTitle
            display
            __typename
          }
          hourlyPm {
            rate
            billableHours
            minBillableHours
            feeTitle
            display
            __typename
          }
          percentPm {
            percent
            minFee
            feeTitle
            display
            __typename
          }
          preTipPm {
            chosenPercent
            percentages
            defaultPercentagesIndex
            footer
            feeTitle
            display
            fixedGratuityOptions
            defaultFixedGratuityOptionsIndex
            chosenFixedGratuity
            gratuityType
            showPreGratuityByDefault
            allowOptionalGratuity
            showCustomGratuity
            __typename
          }
          clientPlatformPm {
            percent
            feeTitle
            display
            __typename
          }
          suggestedFlatPm {
            fee
            feeWarningThreshold
            percentages
            gratuityType
            gratuityOptions
            defaultGratuityOptionsIndex
            clientPaysPlatform
            showCustomGratuity
            title
            description
            __typename
          }
          suggestedPercentPm {
            percent
            minFee
            percentWarningThreshold
            minFeeWarningThreshold
            gratuityType
            gratuityOptions
            defaultGratuityOptionsIndex
            clientPaysPlatform
            showCustomGratuity
            title
            description
            __typename
          }
          suggestedFlatPlusPercentPm {
            fee
            feeWarningThreshold
            percent
            minFee
            percentWarningThreshold
            minFeeWarningThreshold
            gratuityType
            gratuityOptions
            defaultGratuityOptionsIndex
            clientPaysPlatform
            showCustomGratuity
            title
            description
            __typename
          }
          __typename
        }
        disclaimerText
        useSuggestedPricing
        __typename
      }
      serviceArea {
        id
        city
        state
        zipcode
        description
        __typename
      }
      serviceTimes {
        dayOfWeek
        startTime
        endTime
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AssociateClientWithShopperMutationVariables,
  APITypes.AssociateClientWithShopperMutation
>;
export const associateClientWithShopperV2 = /* GraphQL */ `mutation AssociateClientWithShopperV2($input: ReferralLinkInput) {
  associateClientWithShopperV2(input: $input) {
    linkedShopper {
      id
      shopper {
        id
        firstName
        lastName
        displayName
        deliveryArea
        websiteUrl
        phone
        businessPhone
        email
        bio
        image
        businessName
        availabilityDescription
        announcement
        rating
        repeatClientCount
        orderCount
        reviewCount
        specialtyTags
        tagline
        metaTitle
        metaImage
        metaDescription
        deliveryAreaZipcode
        deliveryAreaZipcodes
        deliveryRadius
        lowestPrice
        subscriptionPlan
        subscriptionPlanDetails {
          id
          textComponents {
            text
            bold
            __typename
          }
          phases {
            id
            status
            __typename
          }
          __typename
        }
        branding {
          coverColor
          __typename
        }
        typicalPricing {
          summary {
            title
            description
            __typename
          }
          groceries
          shoppingAndDelivery
          minGratuity
          platform
          __typename
        }
        allowClientConnection
        stripeConnectAcctExists
        fullSSNRequired
        attnBizProfile
        attnDirectDeposit
        attnCreditCard
        attnServices
        attnPassword
        statusIdentityVerification {
          state
          message
          externalLink
          __typename
        }
        statusChargeCard {
          state
          message
          externalLink
          __typename
        }
        optInEngage
        optInZipcode
        deactivated
        acceptsReferralNetwork
        __typename
      }
      serviceOfferings {
        id
        serviceName
        serviceImage
        serviceDescription
        defaultErrandBusinessNames
        baseFee
        maxErrands
        pricingModel {
          version
          description
          flatPm {
            fee
            feeTitle
            display
            __typename
          }
          hourlyPm {
            rate
            billableHours
            minBillableHours
            feeTitle
            display
            __typename
          }
          percentPm {
            percent
            minFee
            feeTitle
            display
            __typename
          }
          preTipPm {
            chosenPercent
            percentages
            defaultPercentagesIndex
            footer
            feeTitle
            display
            fixedGratuityOptions
            defaultFixedGratuityOptionsIndex
            chosenFixedGratuity
            gratuityType
            showPreGratuityByDefault
            allowOptionalGratuity
            showCustomGratuity
            __typename
          }
          clientPlatformPm {
            percent
            feeTitle
            display
            __typename
          }
          suggestedFlatPm {
            fee
            feeWarningThreshold
            percentages
            gratuityType
            gratuityOptions
            defaultGratuityOptionsIndex
            clientPaysPlatform
            showCustomGratuity
            title
            description
            __typename
          }
          suggestedPercentPm {
            percent
            minFee
            percentWarningThreshold
            minFeeWarningThreshold
            gratuityType
            gratuityOptions
            defaultGratuityOptionsIndex
            clientPaysPlatform
            showCustomGratuity
            title
            description
            __typename
          }
          suggestedFlatPlusPercentPm {
            fee
            feeWarningThreshold
            percent
            minFee
            percentWarningThreshold
            minFeeWarningThreshold
            gratuityType
            gratuityOptions
            defaultGratuityOptionsIndex
            clientPaysPlatform
            showCustomGratuity
            title
            description
            __typename
          }
          __typename
        }
        disclaimerText
        useSuggestedPricing
        __typename
      }
      serviceArea {
        id
        city
        state
        zipcode
        description
        __typename
      }
      serviceTimes {
        dayOfWeek
        startTime
        endTime
        __typename
      }
      __typename
    }
    linkedShopperSchedule {
      id
      dailySchedules {
        id
        day
        timeSlots {
          id
          slotStart
          slotEnd
          isActive
          bufferDuration
          bufferMode
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AssociateClientWithShopperV2MutationVariables,
  APITypes.AssociateClientWithShopperV2Mutation
>;
export const connectClientToShopper = /* GraphQL */ `mutation ConnectClientToShopper($shopperId: ID!) {
  connectClientToShopper(shopperId: $shopperId) {
    id
    shopper {
      id
      firstName
      lastName
      displayName
      deliveryArea
      websiteUrl
      phone
      businessPhone
      email
      bio
      image
      businessName
      availabilityDescription
      announcement
      rating
      repeatClientCount
      orderCount
      reviewCount
      specialtyTags
      tagline
      metaTitle
      metaImage
      metaDescription
      deliveryAreaZipcode
      deliveryAreaZipcodes
      deliveryRadius
      lowestPrice
      subscriptionPlan
      subscriptionPlanDetails {
        id
        textComponents {
          text
          bold
          __typename
        }
        phases {
          id
          status
          __typename
        }
        __typename
      }
      branding {
        coverColor
        __typename
      }
      typicalPricing {
        summary {
          title
          description
          __typename
        }
        groceries
        shoppingAndDelivery
        minGratuity
        platform
        __typename
      }
      allowClientConnection
      stripeConnectAcctExists
      fullSSNRequired
      attnBizProfile
      attnDirectDeposit
      attnCreditCard
      attnServices
      attnPassword
      statusIdentityVerification {
        state
        message
        externalLink
        __typename
      }
      statusChargeCard {
        state
        message
        externalLink
        __typename
      }
      optInEngage
      optInZipcode
      deactivated
      acceptsReferralNetwork
      __typename
    }
    serviceOfferings {
      id
      serviceName
      serviceImage
      serviceDescription
      defaultErrandBusinessNames
      baseFee
      maxErrands
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      disclaimerText
      useSuggestedPricing
      __typename
    }
    serviceArea {
      id
      city
      state
      zipcode
      description
      __typename
    }
    serviceTimes {
      dayOfWeek
      startTime
      endTime
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ConnectClientToShopperMutationVariables,
  APITypes.ConnectClientToShopperMutation
>;
export const createSharedList = /* GraphQL */ `mutation CreateSharedList($input: SharedListInput!) {
  createSharedList(input: $input) {
    id
    owner
    listId
    listName
    storeName
    items {
      owner
      listId
      itemId
      catalogId
      position
      name
      image
      unit
      count
      note
      checkedOff
      checkedOffTimestamp
      shopperPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      description
      price
      pricePerUnit
      weight
      weightUnit
      displaySize
      link
      selectedProductOptions {
        name
        selection
        __typename
      }
      __typename
    }
    sharedWith
    clientId
    orderId
    orderTimestamp
    serviceImage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSharedListMutationVariables,
  APITypes.CreateSharedListMutation
>;
export const copySharedList = /* GraphQL */ `mutation CopySharedList($owner: ID!, $listId: ID!) {
  copySharedList(owner: $owner, listId: $listId) {
    operation
    owner
    listId
    itemId
    listName
    storeName
    position
    name
    image
    unit
    count
    note
    checkedOff
    checkedOffTimestamp
    shopperPosition
    shopperCheckedOff
    shopperCheckedOffTimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CopySharedListMutationVariables,
  APITypes.CopySharedListMutation
>;
export const addItemToSharedList = /* GraphQL */ `mutation AddItemToSharedList(
  $owner: ID!
  $listId: ID!
  $input: SharedListItemInput!
) {
  addItemToSharedList(owner: $owner, listId: $listId, input: $input) {
    operation
    owner
    listId
    itemId
    listName
    storeName
    position
    name
    image
    unit
    count
    note
    checkedOff
    checkedOffTimestamp
    shopperPosition
    shopperCheckedOff
    shopperCheckedOffTimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddItemToSharedListMutationVariables,
  APITypes.AddItemToSharedListMutation
>;
export const updateItemOnSharedList = /* GraphQL */ `mutation UpdateItemOnSharedList(
  $owner: ID!
  $listId: ID!
  $itemId: ID!
  $input: SharedListItemInput!
) {
  updateItemOnSharedList(
    owner: $owner
    listId: $listId
    itemId: $itemId
    input: $input
  ) {
    operation
    owner
    listId
    itemId
    listName
    storeName
    position
    name
    image
    unit
    count
    note
    checkedOff
    checkedOffTimestamp
    shopperPosition
    shopperCheckedOff
    shopperCheckedOffTimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateItemOnSharedListMutationVariables,
  APITypes.UpdateItemOnSharedListMutation
>;
export const bulkUpdateItemOnSharedList = /* GraphQL */ `mutation BulkUpdateItemOnSharedList($input: SharedListBulkUpdateInput!) {
  bulkUpdateItemOnSharedList(input: $input) {
    owner
    listId
    mutationId
    items {
      itemId
      position
      name
      image
      unit
      count
      note
      checkedOff
      checkedOffTimestamp
      shopperPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BulkUpdateItemOnSharedListMutationVariables,
  APITypes.BulkUpdateItemOnSharedListMutation
>;
export const deleteItemFromSharedList = /* GraphQL */ `mutation DeleteItemFromSharedList($owner: ID!, $listId: ID!, $itemId: ID!) {
  deleteItemFromSharedList(owner: $owner, listId: $listId, itemId: $itemId) {
    operation
    owner
    listId
    itemId
    listName
    storeName
    position
    name
    image
    unit
    count
    note
    checkedOff
    checkedOffTimestamp
    shopperPosition
    shopperCheckedOff
    shopperCheckedOffTimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteItemFromSharedListMutationVariables,
  APITypes.DeleteItemFromSharedListMutation
>;
export const shareListByPhone = /* GraphQL */ `mutation ShareListByPhone($phone: String!, $owner: ID!, $listId: ID!) {
  shareListByPhone(phone: $phone, owner: $owner, listId: $listId) {
    owner
    listId
    snapshotId
    listName
    storeName
    hasOpenOrder
    clientId
    orderId
    orderTimestamp
    serviceImage
    itemCount
    numItems
    numUnits
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ShareListByPhoneMutationVariables,
  APITypes.ShareListByPhoneMutation
>;
export const addItemToSharedList2 = /* GraphQL */ `mutation AddItemToSharedList2(
  $owner: ID!
  $listId: ID!
  $itemId: ID!
  $input: SharedListItemInput2!
) {
  addItemToSharedList2(
    owner: $owner
    listId: $listId
    itemId: $itemId
    input: $input
  ) {
    operation
    owner
    listId
    itemId
    listName
    storeName
    position
    name
    image
    unit
    count
    note
    checkedOff
    checkedOffTimestamp
    shopperPosition
    shopperCheckedOff
    shopperCheckedOffTimestamp
    description
    price
    pricePerUnit
    weight
    weightUnit
    displaySize
    link
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddItemToSharedList2MutationVariables,
  APITypes.AddItemToSharedList2Mutation
>;
export const updateItemOnSharedList2 = /* GraphQL */ `mutation UpdateItemOnSharedList2(
  $owner: ID!
  $listId: ID!
  $itemId: ID!
  $input: SharedListItemInput2!
) {
  updateItemOnSharedList2(
    owner: $owner
    listId: $listId
    itemId: $itemId
    input: $input
  ) {
    operation
    owner
    listId
    itemId
    listName
    storeName
    position
    name
    image
    unit
    count
    note
    checkedOff
    checkedOffTimestamp
    shopperPosition
    shopperCheckedOff
    shopperCheckedOffTimestamp
    description
    price
    pricePerUnit
    weight
    weightUnit
    displaySize
    link
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateItemOnSharedList2MutationVariables,
  APITypes.UpdateItemOnSharedList2Mutation
>;
export const deleteItemFromSharedList2 = /* GraphQL */ `mutation DeleteItemFromSharedList2($owner: ID!, $listId: ID!, $itemId: ID!) {
  deleteItemFromSharedList2(owner: $owner, listId: $listId, itemId: $itemId) {
    operation
    owner
    listId
    itemId
    listName
    storeName
    position
    name
    image
    unit
    count
    note
    checkedOff
    checkedOffTimestamp
    shopperPosition
    shopperCheckedOff
    shopperCheckedOffTimestamp
    description
    price
    pricePerUnit
    weight
    weightUnit
    displaySize
    link
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteItemFromSharedList2MutationVariables,
  APITypes.DeleteItemFromSharedList2Mutation
>;
export const deleteItemFromPastItemsSharedList = /* GraphQL */ `mutation DeleteItemFromPastItemsSharedList($itemId: ID!, $store: String!) {
  deleteItemFromPastItemsSharedList(itemId: $itemId, store: $store) {
    id
    dumplingId
    sellerName
    name
    sellerId
    available
    allowed
    description
    upc
    categories
    price
    salePrice
    clubPrice
    pricePerUnit
    salePricePerUnit
    unitType
    weightUnit
    weight
    displaySize
    imageLink
    image
    link
    note
    attributedMedia {
      media {
        ... on MediaImage {
          small {
            width
            height
            path
            mimeType
            __typename
          }
          medium {
            width
            height
            path
            mimeType
            __typename
          }
          large {
            width
            height
            path
            mimeType
            __typename
          }
          xlarge {
            width
            height
            path
            mimeType
            __typename
          }
          full {
            width
            height
            path
            mimeType
            __typename
          }
        }
      }
      sourceUrl
      hostPageUrl
      hostPageName
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteItemFromPastItemsSharedListMutationVariables,
  APITypes.DeleteItemFromPastItemsSharedListMutation
>;
export const updateClientReview = /* GraphQL */ `mutation UpdateClientReview($input: ClientReviewInput) {
  updateClientReview(input: $input) {
    id
    quote
    date
    rating
    clientName
    clientImage
    pinned
    hidden
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClientReviewMutationVariables,
  APITypes.UpdateClientReviewMutation
>;
export const connectToClientAccount = /* GraphQL */ `mutation ConnectToClientAccount($clientId: ID!) {
  connectToClientAccount(clientId: $clientId) {
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ConnectToClientAccountMutationVariables,
  APITypes.ConnectToClientAccountMutation
>;
export const addPostTipToOrder = /* GraphQL */ `mutation AddPostTipToOrder(
  $clientId: ID!
  $orderId: ID!
  $orderTimestamp: String!
  $paymentMethodId: ID
  $amount: Int
) {
  addPostTipToOrder(
    clientId: $clientId
    orderId: $orderId
    orderTimestamp: $orderTimestamp
    paymentMethodId: $paymentMethodId
    amount: $amount
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddPostTipToOrderMutationVariables,
  APITypes.AddPostTipToOrderMutation
>;
export const dismissPostTip = /* GraphQL */ `mutation DismissPostTip(
  $clientId: ID!
  $orderId: ID!
  $orderTimestamp: String!
) {
  dismissPostTip(
    clientId: $clientId
    orderId: $orderId
    orderTimestamp: $orderTimestamp
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DismissPostTipMutationVariables,
  APITypes.DismissPostTipMutation
>;
export const dismissReview = /* GraphQL */ `mutation DismissReview(
  $clientId: ID!
  $orderId: ID!
  $orderTimestamp: String!
) {
  dismissReview(
    clientId: $clientId
    orderId: $orderId
    orderTimestamp: $orderTimestamp
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DismissReviewMutationVariables,
  APITypes.DismissReviewMutation
>;
export const leaveOrderReview = /* GraphQL */ `mutation LeaveOrderReview(
  $orderId: ID!
  $orderTimestamp: String!
  $rating: Int!
  $quote: String!
) {
  leaveOrderReview(
    orderId: $orderId
    orderTimestamp: $orderTimestamp
    rating: $rating
    quote: $quote
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LeaveOrderReviewMutationVariables,
  APITypes.LeaveOrderReviewMutation
>;
export const createSosIssue = /* GraphQL */ `mutation CreateSosIssue(
  $reason: String!
  $note: String!
  $orderId: String!
  $deliveryTimestamp: String!
) {
  createSosIssue(
    reason: $reason
    note: $note
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
  ) {
    reason
    note
    orderId
    deliveryTimestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSosIssueMutationVariables,
  APITypes.CreateSosIssueMutation
>;
export const bossCreatePassword = /* GraphQL */ `mutation BossCreatePassword($password: String) {
  bossCreatePassword(password: $password) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BossCreatePasswordMutationVariables,
  APITypes.BossCreatePasswordMutation
>;
export const clientCreatePassword = /* GraphQL */ `mutation ClientCreatePassword($password: String) {
  clientCreatePassword(password: $password) {
    id
    firstName
    lastName
    phone
    email
    image
    referralSource
    hasShopper
    signupTimestamp
    attnPassword
    deactivated
    hasStreamUser
    preferences {
      id
      surveys {
        id
        completedTimestamp
        name
        responses {
          id
          question
          response
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ClientCreatePasswordMutationVariables,
  APITypes.ClientCreatePasswordMutation
>;
export const bossChangePlan = /* GraphQL */ `mutation BossChangePlan($id: ID) {
  bossChangePlan(id: $id) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BossChangePlanMutationVariables,
  APITypes.BossChangePlanMutation
>;
export const bossCreatePaymentMethod = /* GraphQL */ `mutation BossCreatePaymentMethod($stripeToken: String) {
  bossCreatePaymentMethod(stripeToken: $stripeToken) {
    id
    brand
    expirationMonth
    expirationYear
    last4
    isDefault
    address {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BossCreatePaymentMethodMutationVariables,
  APITypes.BossCreatePaymentMethodMutation
>;
export const bossDeletePaymentMethod = /* GraphQL */ `mutation BossDeletePaymentMethod($id: ID) {
  bossDeletePaymentMethod(id: $id) {
    id
    brand
    expirationMonth
    expirationYear
    last4
    isDefault
    address {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BossDeletePaymentMethodMutationVariables,
  APITypes.BossDeletePaymentMethodMutation
>;
export const bossSetDefaultPaymentMethod = /* GraphQL */ `mutation BossSetDefaultPaymentMethod($id: ID) {
  bossSetDefaultPaymentMethod(id: $id) {
    id
    brand
    expirationMonth
    expirationYear
    last4
    isDefault
    address {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BossSetDefaultPaymentMethodMutationVariables,
  APITypes.BossSetDefaultPaymentMethodMutation
>;
export const bossExportEarningsReport = /* GraphQL */ `mutation BossExportEarningsReport($period: String!) {
  bossExportEarningsReport(period: $period)
}
` as GeneratedMutation<
  APITypes.BossExportEarningsReportMutationVariables,
  APITypes.BossExportEarningsReportMutation
>;
export const updateAutoMessage = /* GraphQL */ `mutation UpdateAutoMessage($id: ID!, $input: AutoMessageInput!) {
  updateAutoMessage(id: $id, input: $input) {
    id
    type
    title
    action
    message
    defaultMessage
    description
    enabled
    delaySeconds
    defaultDelaySeconds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAutoMessageMutationVariables,
  APITypes.UpdateAutoMessageMutation
>;
export const createList = /* GraphQL */ `mutation CreateList($storeId: ID) {
  createList(storeId: $storeId) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateListMutationVariables,
  APITypes.CreateListMutation
>;
export const createOrFindList = /* GraphQL */ `mutation CreateOrFindList($storeId: ID) {
  createOrFindList(storeId: $storeId) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrFindListMutationVariables,
  APITypes.CreateOrFindListMutation
>;
export const deleteList = /* GraphQL */ `mutation DeleteList($listId: ID!) {
  deleteList(listId: $listId) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteListMutationVariables,
  APITypes.DeleteListMutation
>;
export const updateItemOnList = /* GraphQL */ `mutation UpdateItemOnList(
  $listId: ID!
  $itemId: ID!
  $itemProperties: ItemPropertiesInput!
) {
  updateItemOnList(
    listId: $listId
    itemId: $itemId
    itemProperties: $itemProperties
  ) {
    product {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    listVersion
    listEstimatedTotal {
      id
      displayPrice
      __typename
    }
    listEstimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateItemOnListMutationVariables,
  APITypes.UpdateItemOnListMutation
>;
export const deleteItemOnList = /* GraphQL */ `mutation DeleteItemOnList($listId: ID!, $itemId: ID!) {
  deleteItemOnList(listId: $listId, itemId: $itemId) {
    product {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    listVersion
    listEstimatedTotal {
      id
      displayPrice
      __typename
    }
    listEstimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteItemOnListMutationVariables,
  APITypes.DeleteItemOnListMutation
>;
export const moveItemBetweenLists = /* GraphQL */ `mutation MoveItemBetweenLists($fromListId: ID!, $toListId: ID!, $itemId: ID!) {
  moveItemBetweenLists(
    fromListId: $fromListId
    toListId: $toListId
    itemId: $itemId
  ) {
    product {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    listVersion
    listEstimatedTotal {
      id
      displayPrice
      __typename
    }
    listEstimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.MoveItemBetweenListsMutationVariables,
  APITypes.MoveItemBetweenListsMutation
>;
export const moveAllItemsBetweenLists = /* GraphQL */ `mutation MoveAllItemsBetweenLists($fromListId: ID!, $toListId: ID!) {
  moveAllItemsBetweenLists(fromListId: $fromListId, toListId: $toListId) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.MoveAllItemsBetweenListsMutationVariables,
  APITypes.MoveAllItemsBetweenListsMutation
>;
export const updateListName = /* GraphQL */ `mutation UpdateListName($listId: ID!, $name: String!) {
  updateListName(listId: $listId, name: $name) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateListNameMutationVariables,
  APITypes.UpdateListNameMutation
>;
export const deleteAllItemsFromList = /* GraphQL */ `mutation DeleteAllItemsFromList($listId: ID!) {
  deleteAllItemsFromList(listId: $listId) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAllItemsFromListMutationVariables,
  APITypes.DeleteAllItemsFromListMutation
>;
export const addItemToList = /* GraphQL */ `mutation AddItemToList(
  $listId: ID!
  $itemId: ID!
  $itemProperties: ItemPropertiesInput!
) {
  addItemToList(
    listId: $listId
    itemId: $itemId
    itemProperties: $itemProperties
  ) {
    product {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    listVersion
    listEstimatedTotal {
      id
      displayPrice
      __typename
    }
    listEstimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddItemToListMutationVariables,
  APITypes.AddItemToListMutation
>;
export const createCustomItemForList = /* GraphQL */ `mutation CreateCustomItemForList(
  $listId: ID!
  $itemProperties: ItemPropertiesInput!
) {
  createCustomItemForList(listId: $listId, itemProperties: $itemProperties) {
    product {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    listVersion
    listEstimatedTotal {
      id
      displayPrice
      __typename
    }
    listEstimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCustomItemForListMutationVariables,
  APITypes.CreateCustomItemForListMutation
>;
export const shopperUpdateItemOnList = /* GraphQL */ `mutation ShopperUpdateItemOnList(
  $listId: ID!
  $itemId: ID!
  $itemProperties: ItemPropertiesInput!
  $owner: ID
  $snapshot: ID
) {
  shopperUpdateItemOnList(
    listId: $listId
    itemId: $itemId
    itemProperties: $itemProperties
    owner: $owner
    snapshot: $snapshot
  ) {
    product {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    listVersion
    listEstimatedTotal {
      id
      displayPrice
      __typename
    }
    listEstimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ShopperUpdateItemOnListMutationVariables,
  APITypes.ShopperUpdateItemOnListMutation
>;
export const shopperUpdateItemsOnList = /* GraphQL */ `mutation ShopperUpdateItemsOnList(
  $listId: ID!
  $changedItems: [ItemChanges!]!
  $owner: ID
  $snapshot: ID
) {
  shopperUpdateItemsOnList(
    listId: $listId
    changedItems: $changedItems
    owner: $owner
    snapshot: $snapshot
  ) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ShopperUpdateItemsOnListMutationVariables,
  APITypes.ShopperUpdateItemsOnListMutation
>;
export const shopperCreateCustomItemForList = /* GraphQL */ `mutation ShopperCreateCustomItemForList(
  $listId: ID!
  $itemProperties: ItemPropertiesInput!
  $owner: ID
  $snapshot: ID
) {
  shopperCreateCustomItemForList(
    listId: $listId
    itemProperties: $itemProperties
    owner: $owner
    snapshot: $snapshot
  ) {
    product {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    listVersion
    listEstimatedTotal {
      id
      displayPrice
      __typename
    }
    listEstimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ShopperCreateCustomItemForListMutationVariables,
  APITypes.ShopperCreateCustomItemForListMutation
>;
export const shopperReplaceItemInList = /* GraphQL */ `mutation ShopperReplaceItemInList(
  $listId: ID!
  $itemId: ID!
  $replacementProperties: ItemPropertiesInput!
  $owner: ID
  $snapshot: ID
) {
  shopperReplaceItemInList(
    listId: $listId
    itemId: $itemId
    replacementProperties: $replacementProperties
    owner: $owner
    snapshot: $snapshot
  ) {
    product {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    listVersion
    listEstimatedTotal {
      id
      displayPrice
      __typename
    }
    listEstimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ShopperReplaceItemInListMutationVariables,
  APITypes.ShopperReplaceItemInListMutation
>;
export const shopperChangeOrderDelivery = /* GraphQL */ `mutation ShopperChangeOrderDelivery(
  $orderId: ID!
  $deliveryTimestamp: String!
  $deliveryChanges: OrderDeliveryChangesInput!
) {
  shopperChangeOrderDelivery(
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
    deliveryChanges: $deliveryChanges
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ShopperChangeOrderDeliveryMutationVariables,
  APITypes.ShopperChangeOrderDeliveryMutation
>;
export const updateLinkedClientAnnotations = /* GraphQL */ `mutation UpdateLinkedClientAnnotations(
  $clientId: ID!
  $annotationChanges: LinkedClientAnnotationsInput!
) {
  updateLinkedClientAnnotations(
    clientId: $clientId
    annotationChanges: $annotationChanges
  ) {
    id
    note
    image
    noteLastUpdatedTimestamp
    preferencesLastUpdatedTimestamp
    preferencesLastSeenTimestamp
    needsToSeePreferences
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLinkedClientAnnotationsMutationVariables,
  APITypes.UpdateLinkedClientAnnotationsMutation
>;
export const createInstantPayoutAccount = /* GraphQL */ `mutation CreateInstantPayoutAccount($input: CreateInstantPayoutAccountInput!) {
  createInstantPayoutAccount(input: $input) {
    ... on InstantPayoutAccount {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      isVerified
    }
  }
}
` as GeneratedMutation<
  APITypes.CreateInstantPayoutAccountMutationVariables,
  APITypes.CreateInstantPayoutAccountMutation
>;
export const updateInstantPayoutAccount = /* GraphQL */ `mutation UpdateInstantPayoutAccount(
  $id: ID!
  $input: UpdateInstantPayoutAccountInput!
) {
  updateInstantPayoutAccount(id: $id, input: $input) {
    id
    brand
    expirationMonth
    expirationYear
    last4
    isDefault
    isVerified
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInstantPayoutAccountMutationVariables,
  APITypes.UpdateInstantPayoutAccountMutation
>;
export const deleteInstantPayoutAccount = /* GraphQL */ `mutation DeleteInstantPayoutAccount($id: ID!) {
  deleteInstantPayoutAccount(id: $id) {
    id
    brand
    expirationMonth
    expirationYear
    last4
    isDefault
    isVerified
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInstantPayoutAccountMutationVariables,
  APITypes.DeleteInstantPayoutAccountMutation
>;
export const issueInstantPayout = /* GraphQL */ `mutation IssueInstantPayout($input: InstantPayoutInput!) {
  issueInstantPayout(input: $input) {
    id
    balance
    fee
    amount
    arrivalTimestamp
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.IssueInstantPayoutMutationVariables,
  APITypes.IssueInstantPayoutMutation
>;
export const requestVirtualCard = /* GraphQL */ `mutation RequestVirtualCard {
  requestVirtualCard
}
` as GeneratedMutation<
  APITypes.RequestVirtualCardMutationVariables,
  APITypes.RequestVirtualCardMutation
>;
export const requestCustomUrl = /* GraphQL */ `mutation RequestCustomUrl {
  requestCustomUrl
}
` as GeneratedMutation<
  APITypes.RequestCustomUrlMutationVariables,
  APITypes.RequestCustomUrlMutation
>;
export const reportIncorrectProductDetails = /* GraphQL */ `mutation ReportIncorrectProductDetails($itemId: ID!) {
  reportIncorrectProductDetails(itemId: $itemId)
}
` as GeneratedMutation<
  APITypes.ReportIncorrectProductDetailsMutationVariables,
  APITypes.ReportIncorrectProductDetailsMutation
>;
export const adoptCart = /* GraphQL */ `mutation AdoptCart($proposedCartId: ID!, $replaceCart: Boolean) {
  adoptCart(proposedCartId: $proposedCartId, replaceCart: $replaceCart) {
    cart {
      id
      type
      clientId
      shopper {
        id
        image
        displayName
        isPro
        clientCount
        repeatClientCount
        __typename
      }
      deliveryTimeSlot {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      preTip {
        percent
        fixed
        __typename
      }
      note
      services {
        id
        serviceName
        serviceImage
        listIds
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      paymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      appliedPromos {
        id
        type
        code
        displayName
        discountFixed
        discountPercent
        __typename
      }
      estimatedTotals {
        type
        label
        value
        __typename
      }
      createdOn
      lastUpdated
      __typename
    }
    errors {
      code
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AdoptCartMutationVariables,
  APITypes.AdoptCartMutation
>;
export const adoptCartWithUpdates = /* GraphQL */ `mutation AdoptCartWithUpdates(
  $proposedCartId: ID!
  $cartUpdates: CartInput!
  $replaceCart: Boolean
) {
  adoptCartWithUpdates(
    proposedCartId: $proposedCartId
    cartUpdates: $cartUpdates
    replaceCart: $replaceCart
  ) {
    cart {
      id
      type
      clientId
      shopper {
        id
        image
        displayName
        isPro
        clientCount
        repeatClientCount
        __typename
      }
      deliveryTimeSlot {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      preTip {
        percent
        fixed
        __typename
      }
      note
      services {
        id
        serviceName
        serviceImage
        listIds
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      paymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      appliedPromos {
        id
        type
        code
        displayName
        discountFixed
        discountPercent
        __typename
      }
      estimatedTotals {
        type
        label
        value
        __typename
      }
      createdOn
      lastUpdated
      __typename
    }
    errors {
      code
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AdoptCartWithUpdatesMutationVariables,
  APITypes.AdoptCartWithUpdatesMutation
>;
export const updateCart = /* GraphQL */ `mutation UpdateCart($cartUpdates: CartInput!) {
  updateCart(cartUpdates: $cartUpdates) {
    cart {
      id
      type
      clientId
      shopper {
        id
        image
        displayName
        isPro
        clientCount
        repeatClientCount
        __typename
      }
      deliveryTimeSlot {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      preTip {
        percent
        fixed
        __typename
      }
      note
      services {
        id
        serviceName
        serviceImage
        listIds
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      paymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      appliedPromos {
        id
        type
        code
        displayName
        discountFixed
        discountPercent
        __typename
      }
      estimatedTotals {
        type
        label
        value
        __typename
      }
      createdOn
      lastUpdated
      __typename
    }
    errors {
      code
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCartMutationVariables,
  APITypes.UpdateCartMutation
>;
export const addListToCart = /* GraphQL */ `mutation AddListToCart($listId: ID!, $replaceCart: Boolean) {
  addListToCart(listId: $listId, replaceCart: $replaceCart) {
    cart {
      id
      type
      clientId
      shopper {
        id
        image
        displayName
        isPro
        clientCount
        repeatClientCount
        __typename
      }
      deliveryTimeSlot {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      preTip {
        percent
        fixed
        __typename
      }
      note
      services {
        id
        serviceName
        serviceImage
        listIds
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      paymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      appliedPromos {
        id
        type
        code
        displayName
        discountFixed
        discountPercent
        __typename
      }
      estimatedTotals {
        type
        label
        value
        __typename
      }
      createdOn
      lastUpdated
      __typename
    }
    errors {
      code
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddListToCartMutationVariables,
  APITypes.AddListToCartMutation
>;
export const removeListFromCart = /* GraphQL */ `mutation RemoveListFromCart($listId: ID!) {
  removeListFromCart(listId: $listId) {
    cart {
      id
      type
      clientId
      shopper {
        id
        image
        displayName
        isPro
        clientCount
        repeatClientCount
        __typename
      }
      deliveryTimeSlot {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      preTip {
        percent
        fixed
        __typename
      }
      note
      services {
        id
        serviceName
        serviceImage
        listIds
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      paymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      appliedPromos {
        id
        type
        code
        displayName
        discountFixed
        discountPercent
        __typename
      }
      estimatedTotals {
        type
        label
        value
        __typename
      }
      createdOn
      lastUpdated
      __typename
    }
    errors {
      code
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveListFromCartMutationVariables,
  APITypes.RemoveListFromCartMutation
>;
export const createOrderWithCart = /* GraphQL */ `mutation CreateOrderWithCart {
  createOrderWithCart {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderWithCartMutationVariables,
  APITypes.CreateOrderWithCartMutation
>;
export const createAdditionalOrder = /* GraphQL */ `mutation CreateAdditionalOrder(
  $deliveryTimestamp: String!
  $orderId: ID!
  $flatFee: String!
  $percent: String!
  $applyGratuity: Boolean!
) {
  createAdditionalOrder(
    deliveryTimestamp: $deliveryTimestamp
    orderId: $orderId
    flatFee: $flatFee
    percent: $percent
    applyGratuity: $applyGratuity
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAdditionalOrderMutationVariables,
  APITypes.CreateAdditionalOrderMutation
>;
export const deactivateClient = /* GraphQL */ `mutation DeactivateClient($id: ID!) {
  deactivateClient(id: $id) {
    id
    firstName
    lastName
    phone
    email
    image
    referralSource
    hasShopper
    signupTimestamp
    attnPassword
    deactivated
    hasStreamUser
    preferences {
      id
      surveys {
        id
        completedTimestamp
        name
        responses {
          id
          question
          response
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeactivateClientMutationVariables,
  APITypes.DeactivateClientMutation
>;
export const activateClient = /* GraphQL */ `mutation ActivateClient($id: ID!) {
  activateClient(id: $id) {
    id
    firstName
    lastName
    phone
    email
    image
    referralSource
    hasShopper
    signupTimestamp
    attnPassword
    deactivated
    hasStreamUser
    preferences {
      id
      surveys {
        id
        completedTimestamp
        name
        responses {
          id
          question
          response
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ActivateClientMutationVariables,
  APITypes.ActivateClientMutation
>;
export const deleteClient = /* GraphQL */ `mutation DeleteClient($id: ID!) {
  deleteClient(id: $id) {
    id
    firstName
    lastName
    phone
    email
    image
    referralSource
    hasShopper
    signupTimestamp
    attnPassword
    deactivated
    hasStreamUser
    preferences {
      id
      surveys {
        id
        completedTimestamp
        name
        responses {
          id
          question
          response
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClientMutationVariables,
  APITypes.DeleteClientMutation
>;
export const deactivateShopper = /* GraphQL */ `mutation DeactivateShopper($id: ID!) {
  deactivateShopper(id: $id) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeactivateShopperMutationVariables,
  APITypes.DeactivateShopperMutation
>;
export const activateShopper = /* GraphQL */ `mutation ActivateShopper($id: ID!) {
  activateShopper(id: $id) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ActivateShopperMutationVariables,
  APITypes.ActivateShopperMutation
>;
export const updateShopperFundingInfo = /* GraphQL */ `mutation UpdateShopperFundingInfo(
  $id: ID!
  $fundingProfile: String
  $virtualBalance: Int
  $transactionLimit: Int
) {
  updateShopperFundingInfo(
    id: $id
    fundingProfile: $fundingProfile
    virtualBalance: $virtualBalance
    transactionLimit: $transactionLimit
  ) {
    id
    fundingProfile
    merchantCategoryId
    transactionLimit
    dailySpendLimit
    dailySpendLimitCeiling
    virtualBalance
    todaysSpend
    fundingPerOrder
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShopperFundingInfoMutationVariables,
  APITypes.UpdateShopperFundingInfoMutation
>;
export const reopenOrder = /* GraphQL */ `mutation ReopenOrder(
  $id: ID!
  $orderId: ID!
  $deliveryTimestamp: String!
  $orderTimestamp: String!
  $clientId: ID!
) {
  reopenOrder(
    id: $id
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
    orderTimestamp: $orderTimestamp
    clientId: $clientId
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReopenOrderMutationVariables,
  APITypes.ReopenOrderMutation
>;
export const uncancelOrder = /* GraphQL */ `mutation UncancelOrder(
  $id: ID!
  $orderId: ID!
  $deliveryTimestamp: String!
  $orderTimestamp: String!
  $clientId: ID!
) {
  uncancelOrder(
    id: $id
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
    orderTimestamp: $orderTimestamp
    clientId: $clientId
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UncancelOrderMutationVariables,
  APITypes.UncancelOrderMutation
>;
export const moveOrder = /* GraphQL */ `mutation MoveOrder(
  $srcShopperId: ID!
  $dstShopperId: ID!
  $orderId: ID!
  $deliveryTimestamp: String!
) {
  moveOrder(
    srcShopperId: $srcShopperId
    dstShopperId: $dstShopperId
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
  )
}
` as GeneratedMutation<
  APITypes.MoveOrderMutationVariables,
  APITypes.MoveOrderMutation
>;
export const updateTransaction = /* GraphQL */ `mutation UpdateTransaction(
  $shopperId: ID!
  $cardAcctId: ID!
  $transactionType: ID!
  $transactionId: ID!
  $input: TransactionFullInput
) {
  updateTransaction(
    shopperId: $shopperId
    cardAcctId: $cardAcctId
    transactionType: $transactionType
    transactionId: $transactionId
    input: $input
  ) {
    id
    update_time
    merchantName
    merchantCity
    merchantState
    merchantZip
    merchantCountry
    merchantLocalTime
    transactionUtcTime
    transactionAmount
    image
    ignore
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTransactionMutationVariables,
  APITypes.UpdateTransactionMutation
>;
export const updateOrderPricing = /* GraphQL */ `mutation UpdateOrderPricing(
  $orderId: ID!
  $deliveryTimestamp: String!
  $flatFee: String!
  $percent: String!
  $minFee: String!
  $clientPaysPlatform: Boolean!
  $platformDisplayName: String
  $chosenPercent: String
  $chosenFixedGratuity: String
) {
  updateOrderPricing(
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
    flatFee: $flatFee
    percent: $percent
    minFee: $minFee
    clientPaysPlatform: $clientPaysPlatform
    platformDisplayName: $platformDisplayName
    chosenPercent: $chosenPercent
    chosenFixedGratuity: $chosenFixedGratuity
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderPricingMutationVariables,
  APITypes.UpdateOrderPricingMutation
>;
export const createSyntheticTransaction = /* GraphQL */ `mutation CreateSyntheticTransaction(
  $cardAcctId: ID!
  $input: SyntheticTransactionInput
) {
  createSyntheticTransaction(cardAcctId: $cardAcctId, input: $input) {
    id
    update_time
    merchantName
    merchantCity
    merchantState
    merchantZip
    merchantCountry
    merchantLocalTime
    transactionUtcTime
    transactionAmount
    image
    ignore
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSyntheticTransactionMutationVariables,
  APITypes.CreateSyntheticTransactionMutation
>;
export const updateShopperSubscription = /* GraphQL */ `mutation UpdateShopperSubscription($id: ID, $subscriptionPlan: String) {
  updateShopperSubscription(id: $id, subscriptionPlan: $subscriptionPlan) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateShopperSubscriptionMutationVariables,
  APITypes.UpdateShopperSubscriptionMutation
>;
export const adoptCartFromActivity = /* GraphQL */ `mutation AdoptCartFromActivity($activityId: ID!) {
  adoptCartFromActivity(activityId: $activityId) {
    cart {
      id
      type
      clientId
      shopper {
        id
        image
        displayName
        isPro
        clientCount
        repeatClientCount
        __typename
      }
      deliveryTimeSlot {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      preTip {
        percent
        fixed
        __typename
      }
      note
      services {
        id
        serviceName
        serviceImage
        listIds
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      paymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      appliedPromos {
        id
        type
        code
        displayName
        discountFixed
        discountPercent
        __typename
      }
      estimatedTotals {
        type
        label
        value
        __typename
      }
      createdOn
      lastUpdated
      __typename
    }
    errors {
      code
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AdoptCartFromActivityMutationVariables,
  APITypes.AdoptCartFromActivityMutation
>;
export const assignLinkedOrdersTo = /* GraphQL */ `mutation AssignLinkedOrdersTo($input: AssignLinkedOrdersToInput) {
  assignLinkedOrdersTo(input: $input) {
    orders {
      version
      id
      clientId
      shopperId
      shopperInfo {
        image
        displayName
        email
        __typename
      }
      firstName
      lastName
      phone
      email
      clientImage
      note
      privateNote
      adminNote
      conciergeNote
      orderStatus
      orderDateTime
      orderTimestamp
      deliveryDate
      deliveryTime
      deliveryTimestamp
      deliveryStartDateTime
      deliveryEndDateTime
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      orderPaymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      serviceRequestList {
        serviceId
        serviceName
        image
        errandList {
          businessName
          shoppingItemCount
          shoppingList {
            id
            itemName
            itemNote
            isDone
            __typename
          }
          __typename
        }
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      tip
      feeAndPreGratuityDisplay
      deliveryFee
      transactions
      couponCode
      adjustmentDescription
      adjustmentAmount
      adjustments {
        id
        description
        amount
        __typename
      }
      lineItems {
        deliveryFee
        tipPercentage
        tipAmount
        platformPercentage
        platformAmount
        subtotal
        coupon
        total
        earnings
        stores {
          storeName
          storeAmount
          __typename
        }
        couponCode
        additionalTipAmount
        adjustmentDescription
        adjustmentAmount
        __typename
      }
      priceBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      earningsBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      review {
        id
        quote
        rating
        timestamp
        __typename
      }
      sharedListIdentifiers {
        owner
        listId
        snapshotId
        listName
        storeName
        hasOpenOrder
        clientId
        orderId
        orderTimestamp
        serviceImage
        itemCount
        numItems
        numUnits
        __typename
      }
      listReferences {
        storeName
        storeImage
        storeId
        id
        listName
        listItemCount
        listVersion
        lastCompletedOrderId
        savedListId
        savedListItemCount
        savedListVersion
        __typename
      }
      additionalTipAmount
      additionalTipDismissed
      pricingData {
        preTip
        loan
        __typename
      }
      externalTransactions {
        id
        description
        amount
        image
        attachment
        __typename
      }
      assignedTo
      lockoutHours
      parentOrder {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      childOrders {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      credits {
        id
        description
        amount
        __typename
      }
      __typename
    }
    nextToken
    prevToken
    pageNumber
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AssignLinkedOrdersToMutationVariables,
  APITypes.AssignLinkedOrdersToMutation
>;
export const resortDeleteClosedDate = /* GraphQL */ `mutation ResortDeleteClosedDate($id: ID!) {
  resortDeleteClosedDate(id: $id)
}
` as GeneratedMutation<
  APITypes.ResortDeleteClosedDateMutationVariables,
  APITypes.ResortDeleteClosedDateMutation
>;
export const resortCreateClosedDate = /* GraphQL */ `mutation ResortCreateClosedDate($date: String!) {
  resortCreateClosedDate(date: $date) {
    id
    date
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ResortCreateClosedDateMutationVariables,
  APITypes.ResortCreateClosedDateMutation
>;
export const bossConfirmForgotPassword = /* GraphQL */ `mutation BossConfirmForgotPassword(
  $phone: String
  $code: String
  $password: String
) {
  bossConfirmForgotPassword(phone: $phone, code: $code, password: $password) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BossConfirmForgotPasswordMutationVariables,
  APITypes.BossConfirmForgotPasswordMutation
>;
export const clientConfirmForgotPassword = /* GraphQL */ `mutation ClientConfirmForgotPassword(
  $phone: String
  $code: String
  $password: String
) {
  clientConfirmForgotPassword(phone: $phone, code: $code, password: $password) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ClientConfirmForgotPasswordMutationVariables,
  APITypes.ClientConfirmForgotPasswordMutation
>;
export const clientCreateAccount = /* GraphQL */ `mutation ClientCreateAccount($phone: String) {
  clientCreateAccount(phone: $phone) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ClientCreateAccountMutationVariables,
  APITypes.ClientCreateAccountMutation
>;
export const bossChangePhone = /* GraphQL */ `mutation BossChangePhone($shopperId: ID, $newPhone: String, $oldPhone: String) {
  bossChangePhone(
    shopperId: $shopperId
    newPhone: $newPhone
    oldPhone: $oldPhone
  ) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BossChangePhoneMutationVariables,
  APITypes.BossChangePhoneMutation
>;
export const clientChangePhone = /* GraphQL */ `mutation ClientChangePhone(
  $clientId: ID
  $newPhone: String
  $oldPhone: String
) {
  clientChangePhone(
    clientId: $clientId
    newPhone: $newPhone
    oldPhone: $oldPhone
  ) {
    id
    firstName
    lastName
    phone
    email
    image
    referralSource
    hasShopper
    signupTimestamp
    attnPassword
    deactivated
    hasStreamUser
    preferences {
      id
      surveys {
        id
        completedTimestamp
        name
        responses {
          id
          question
          response
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ClientChangePhoneMutationVariables,
  APITypes.ClientChangePhoneMutation
>;
export const globalLogoutUser = /* GraphQL */ `mutation GlobalLogoutUser($id: ID!, $service: String!, $app: String!) {
  globalLogoutUser(id: $id, service: $service, app: $app) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GlobalLogoutUserMutationVariables,
  APITypes.GlobalLogoutUserMutation
>;
export const notifyListChange = /* GraphQL */ `mutation NotifyListChange($listId: ID!) {
  notifyListChange(listId: $listId) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyListChangeMutationVariables,
  APITypes.NotifyListChangeMutation
>;
export const notifyCardFundingChange = /* GraphQL */ `mutation NotifyCardFundingChange($userId: ID!) {
  notifyCardFundingChange(userId: $userId) {
    userId
    fundingCents
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyCardFundingChangeMutationVariables,
  APITypes.NotifyCardFundingChangeMutation
>;
export const remapUser = /* GraphQL */ `mutation RemapUser(
  $userType: String!
  $fromId: ID!
  $toId: ID!
  $expiresAt: String
) {
  remapUser(
    userType: $userType
    fromId: $fromId
    toId: $toId
    expiresAt: $expiresAt
  ) {
    userId
    phoneNumber
    email
    type
    expiresAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemapUserMutationVariables,
  APITypes.RemapUserMutation
>;
export const createProposedCartDeepLink = /* GraphQL */ `mutation CreateProposedCartDeepLink($cartInput: ProposedCartInput!) {
  createProposedCartDeepLink(cartInput: $cartInput)
}
` as GeneratedMutation<
  APITypes.CreateProposedCartDeepLinkMutationVariables,
  APITypes.CreateProposedCartDeepLinkMutation
>;
export const updateBossBuddy = /* GraphQL */ `mutation UpdateBossBuddy($input: BossBuddyInput!) {
  updateBossBuddy(input: $input) {
    id
    name
    phone
    permissionLevel
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBossBuddyMutationVariables,
  APITypes.UpdateBossBuddyMutation
>;
export const deleteBossBuddy = /* GraphQL */ `mutation DeleteBossBuddy($buddyId: ID!) {
  deleteBossBuddy(buddyId: $buddyId)
}
` as GeneratedMutation<
  APITypes.DeleteBossBuddyMutationVariables,
  APITypes.DeleteBossBuddyMutation
>;
export const createBossBuddy = /* GraphQL */ `mutation CreateBossBuddy($input: CreateBossBuddyInput!) {
  createBossBuddy(input: $input) {
    id
    name
    phone
    permissionLevel
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBossBuddyMutationVariables,
  APITypes.CreateBossBuddyMutation
>;

export const partialRefundOrder = /* GraphQL */ `mutation PartialRefundOrder(
  $id: ID!
  $orderId: ID!
  $deliveryTimestamp: String!
  $orderTimestamp: String!
  $clientId: ID!
  $refundAmount: Int!
  $refundReason: String!
) {
  partialRefundOrder(
    id: $id
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
    orderTimestamp: $orderTimestamp
    clientId: $clientId
    refundAmount: $refundAmount
    refundReason: $refundReason
  ) {
    id
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        __typename
      }
      final {
        key
        value
        type
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        __typename
      }
      final {
        key
        value
        type
        __typename
      }
      __typename
    }
    __typename
  }
}
`;

export const addDeliveryImage = /* GraphQL */ `mutation AddDeliveryImage(
  $orderId: ID!
  $deliveryTimestamp: String!
  $imageLocation: String!
) {
  addDeliveryImage(
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
    imageLocation: $imageLocation
  )
}
` as GeneratedMutation<
  APITypes.AddDeliveryImageMutationVariables,
  APITypes.AddDeliveryImageMutation
>;

export const deleteDeliveryImage = /* GraphQL */ `mutation DeleteDeliveryImage(
  $orderId: ID!
  $deliveryTimestamp: String!
  $imageLocation: String!
) {
  deleteDeliveryImage(
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
    imageLocation: $imageLocation
  )
}
` as GeneratedMutation<
  APITypes.DeleteDeliveryImageMutationVariables,
  APITypes.DeleteDeliveryImageMutation
>;
